/* storybook-check-ignore */
import { HeaderLogo } from 'components/exclusives/layout/Headerv2/HeaderLogo/HeaderLogo';
import HeaderNavigation from 'components/exclusives/layout/Headerv2/HeaderNavigation/HeaderNavigation';
import { HeaderSearch } from 'components/exclusives/layout/Headerv2/HeaderSearch/HeaderSearch';
import LoggedInConnector, { AccountProps } from 'components/shared/AccountConnector';
import { useEffect } from 'react';

import { Flex, LogoProps } from '@opendoor/bricks/core';
import SelectiveSpritesheet from '@opendoor/bricks/core/Icon/SelectiveSpritesheet';
import ArrowLeft from '@opendoor/bricks/core/Icon/SpritesheetIcons/ArrowLeft';
import AvatarFilled from '@opendoor/bricks/core/Icon/SpritesheetIcons/AvatarFilled';
import Close from '@opendoor/bricks/core/Icon/SpritesheetIcons/Close';
import Favorite from '@opendoor/bricks/core/Icon/SpritesheetIcons/Favorite';
import Filter from '@opendoor/bricks/core/Icon/SpritesheetIcons/Filter';
import Menu from '@opendoor/bricks/core/Icon/SpritesheetIcons/Menu';
import Search from '@opendoor/bricks/core/Icon/SpritesheetIcons/Search';

export type HeaderV2Props = AccountProps & {
  logoHref?: LogoProps['href'];
  isFullWidth?: boolean;
  isNavigationHidden?: boolean;
  isSearchHidden?: boolean;
  maxWidth?: string;
};

export const HeaderV2 = ({
  isFullWidth = false,
  isNavigationHidden = false,
  isSearchHidden = false,
  logoHref,
  maxWidth = 'var(--content-full-max-width)',
  maybeFetchSessionInfo,
  maybeFetchSessionLeads,
}: HeaderV2Props) => {
  useEffect(() => {
    maybeFetchSessionInfo();
    maybeFetchSessionLeads();
  }, []);

  return (
    <>
      <SelectiveSpritesheet
        icons={[ArrowLeft, AvatarFilled, Close, Favorite, Filter, Menu, Search]}
      />
      <Flex
        alignItems="center"
        as="header"
        backgroundColor="neutrals0"
        borderBottom="1px solid"
        borderColor="neutrals40"
        left={0}
        height={72}
        maxWidth="100%"
        position="sticky"
        top={0}
        right={0}
        zIndex={9}
      >
        <Flex
          alignItems="center"
          gap={5}
          justifyContent="space-between"
          maxWidth={isFullWidth ? '100%' : maxWidth}
          mx="auto"
          pl={[24, null, 40]}
          pr={[24, null, 28]}
          position="relative"
          width="100%"
          /**
           * This is to prevent the search bar from overflowing the header on
           * mobile devices.
           */
          overflow={['hidden', null, null, 'visible']}
        >
          <Flex alignItems="center" flexGrow={1} gap={[3, null, null, 5]}>
            <HeaderLogo href={logoHref} />

            {!isSearchHidden && <HeaderSearch />}
          </Flex>

          {!isNavigationHidden && <HeaderNavigation />}
        </Flex>
      </Flex>
    </>
  );
};

export default LoggedInConnector(HeaderV2);
